import styled from 'styled-components';

export const WrapperColors = styled.div`
  width: 200px;
  height: auto;
`;
